export default __webpack_public_path__ + "static/media/lidye-1Shk_PkNkNw-unsplash.1b0548c3.jpg";